import { C } from "../customers/theme";

// AtlasRobot.jsx — PLACEHOLDER artwork (P4-CC12). The Claude Design export
// (design-reference/atlas-robot.html) does not exist in this repo yet; this is
// a plain, static SVG standing in for it. Purely presentational — no state, no
// logic, props only. Nothing outside this file should need to change when the
// real design is dropped in: swap this component's internals, keep the same
// { size, isAnimating } props and the same default export.
//
// Static inline SVG only — no canvas/WebGL/continuous JS animation loop, since
// this renders on every authenticated screen and must not drain a phone
// battery. The idle animation is the existing `.ai-pulse` CSS class (2s
// infinite glow, src/index.css) — the caller decides whether
// prefers-reduced-motion allows it and passes that decision in via `isAnimating`.
export default function AtlasRobot({ size = 32, isAnimating = false }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 48 48" fill="none"
      xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
      className={isAnimating ? "ai-pulse" : undefined}
      style={{ borderRadius: "50%", display: "block" }}
    >
      <circle cx="24" cy="24" r="24" fill={C.primary} />
      <rect x="14" y="16" width="20" height="16" rx="6" fill={C.bg} />
      <circle cx="20" cy="24" r="2.5" fill={C.primary} />
      <circle cx="28" cy="24" r="2.5" fill={C.primary} />
      <rect x="21" y="29.5" width="6" height="1.6" rx="0.8" fill={C.primary} />
      <rect x="22.5" y="9" width="3" height="6" rx="1.5" fill={C.bg} />
      <circle cx="24" cy="8" r="2.4" fill={C.primary} />
    </svg>
  );
}
